import React, { useState } from 'react';
import { generarDescripcion } from '../services/iaService';
import { useToast } from '../context/ToastContext';

// Textarea de descripción con botón "Generar con IA".
// `datosProducto` son los campos que se le pasan a Claude como contexto.
export default function CampoDescripcionIA({ valor, onChange, datosProducto, deshabilitado }) {
  const [generando, setGenerando] = useState(false);
  const { mostrarToast } = useToast();

  const puedeGenerar = Boolean(datosProducto.nombre && datosProducto.nombre.trim());

  const generar = async () => {
    if (!puedeGenerar) {
      mostrarToast('Escribe primero el nombre del producto', 'error');
      return;
    }
    setGenerando(true);
    try {
      onChange(await generarDescripcion(datosProducto));
      mostrarToast('Descripción generada ✨', 'exito');
    } catch (e) {
      // El servicio propaga el mensaje claro (ej. sin créditos de IA).
      mostrarToast(e?.message || 'No se pudo generar la descripción. Intenta de nuevo.', 'error', 6000);
    } finally {
      setGenerando(false);
    }
  };

  return (
    <div style={{ marginBottom: '14px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
        <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151' }}>Descripción</label>
        <button type="button" onClick={generar} disabled={generando || deshabilitado}
          style={{ padding: '4px 10px', backgroundColor: generando ? '#E5E7EB' : '#F3E8FF', color: generando ? '#6B7280' : '#7C3AED', border: '1px solid #DDD6FE', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: generando ? 'wait' : 'pointer' }}>
          {generando ? '⏳ Generando...' : '✨ Generar con IA'}
        </button>
      </div>
      <textarea value={valor ?? ''} disabled={generando || deshabilitado} rows={3}
        placeholder="Descripción del producto (opcional) — o genérala con IA"
        onChange={(e) => onChange(e.target.value)}
        style={{ width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '13px', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' }} />
    </div>
  );
}
